'use strict';

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');
const Formatters=require('../../../dist-es6/client/formatters');let

RippleButtonDirective=class RippleButtonDirective extends BaseDirective{
get restrict(){
return'A';
}

link($scope,$element,$attrs){
const color=$attrs.pulsarRippleButton!=='pulsar-ripple-button'&&$attrs.pulsarRippleButton.length!==0?$attrs.pulsarRippleButton:null;
const _buttonElement=angular.element($element);

_buttonElement.on('click',event=>{
fastdom.measure(()=>{
const{top:buttonTop,left:buttonLeft}=_buttonElement.offset();
const X=event.pageX-buttonLeft;
const Y=event.pageY-buttonTop;

let styles=`top: ${Y}px; left: ${X}px;`;
if(color){
styles+=`background-color: ${color};`;
}

fastdom.mutate(()=>{
const _rippleDiv=angular.element(`<div class="ripple" style="${styles}"></div>`);
_buttonElement.append(_rippleDiv);
setTimeout(()=>{
fastdom.mutate(()=>{
const el=angular.element(_rippleDiv);
if(el){
el.remove();
}
});
},900);
});
});
});
}};


module.exports=RippleButtonDirective;
//# sourceMappingURL=rippleButtonDirective.js.map
